<!-- 订单详情 -->
<template>
  <div class="order-details business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div class="order-details-main">
      <div class="order-status">
        <div class="order-status1">
          <div>订单号：{{tableData.OrderCode}}</div>
          <div class="status-text">{{tableData.StateName}}</div>
          <div v-if="!tableData.IsInvoiced && tableData.State >= 20">
            <el-button size="small" @click="showInvoice">申请开票</el-button>
          </div>
          <div>
            <el-button size="small" class="btn-primary pingj-btn" v-if="tableData.State >= 5">评价</el-button>
          </div>
          <div class="print">
            <i class="fa fa-print"></i>打印订单
          </div>
        </div>
        <div class="order-status2">
          <div class="order-dur">{{tableData.StateName}}</div>
          <el-steps :active="stateSp" align-center>
            <el-step :key="index" v-for="(item,index) in tableData.OrderStates" :title="item.State"></el-step>
          </el-steps>
        </div>
      </div>
      <!--订单信息-->
      <el-card class="box-card order-msg-ctn">
        <div class="order-msg">
          <div class="receive-msg order-msg-item">
            <div class="order-msg-title">收货人信息</div>
            <div>
              <div class="key">收货人</div>
              <div class="value">{{tableData.Consignee}}</div>
            </div>
            <div>
              <div class="key">地址</div>
              <div class="value">{{tableData.ShipAddr}}</div>
            </div>
            <div>
              <div class="key">电话号码</div>
              <div class="value">{{tableData.PhoneNum}}</div>
            </div>
          </div>
          <div class="send-msg order-msg-item">
            <div class="order-msg-title">配送信息</div>
            <div>
              <div class="key">配送方式</div>
              <div class="value">{{tableData.ShipTypeName}}</div>
            </div>
            <div>
              <div class="key">运费</div>
              <div class="value">{{tableData.ShipAmount}}</div>
            </div>
            <!--<div>-->
            <!--<div class="key">期望送货日期</div>-->
            <!--<div class="value">未返回</div>-->
            <!--</div>-->
            <!--<div>-->
            <!--<div class="key">期望配送时间</div>-->
            <!--<div class="value">未返回</div>-->
            <!--</div>-->
          </div>
          <div class="pay-msg order-msg-item">
            <div class="order-msg-title">付款信息</div>
            <div>
              <div class="key">付款方式</div>
              <div class="value">{{tableData.PayTypeName}}</div>
            </div>
            <div>
              <div class="key">付款时间</div>
              <div class="value">{{tableData.CreateTime}}</div>
            </div>
            <div>
              <div class="key">商品总额</div>
              <div class="value">￥{{tableData.OrderAmount}}</div>
            </div>
            <div>
              <div class="key">应支付金额</div>
              <div class="value">￥{{tableData.SurplusMoney}}</div>
            </div>
            <div>
              <div class="key">优惠</div>
              <div class="value">￥{{tableData.DiscountAmount}}</div>
            </div>
          </div>
          <div class="invoice order-msg-item">
            <div class="order-msg-title">发票信息</div>
            <template v-if="tableData.IsInvoiced">
              <template>
                <div :key="index" v-for="(item,index) in tableData.Invoices">
                  <div>
                    <div class="key">发票抬头</div>
                    <div class="value">{{item.TitleId}}</div>
                  </div>
                  <div>
                    <div class="key">发票类型</div>
                    <div class="value">{{item.TypeName}}</div>
                  </div>
                  <div>
                    <div class="key">发票内容</div>
                    <div class="value">{{item.InvoiceContent}}</div>
                  </div>
                </div>
              </template>
            </template>
            <div v-else>
              <div>暂无发票信息</div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div style="padding: 10px">
          <div class="table-ctn">
            <el-table :data="tableData.GoodsList" style="width: 100%">
              <el-table-column show-overflow-tooltip width="390" label="商品">
                <template slot-scope="scope">
                  <div class="shop-msg">
                    <div class="image-ctn">
                      <img
                        :src="downloadUrl+scope.row.MainImg"
                        :onerror="defaultImg"
                        class="shop-cover"
                      />
                    </div>
                    <span
                      style="margin-left: 10px"
                      :title="scope.row.GoodsName"
                    >{{scope.row.GoodsName}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="GoodCode" label="商品编号"></el-table-column>
              <el-table-column show-overflow-tooltip prop="Price" label="价格(元)"></el-table-column>
              <el-table-column show-overflow-tooltip prop="Count" label="商品数量"></el-table-column>
              <el-table-column fixed="right" label="操作" :autoWidth="true">
                <template slot-scope="scope">
                  <div class="ops-ctn">
                    <el-button
                      v-if="tableData.State > 15"
                      @click="gotoApplyDetails(scope.row.OrderGoodRId)"
                      size="mini"
                      type="text"
                    >申请售后</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="money-msg">
            <div>
              <div class="money-item">
                <span class="key">商品总额：</span>
                <span class="value">￥{{tableData.OrderAmount}}</span>
              </div>
              <div class="money-item">
                <span class="key">优&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;惠：</span>
                <span class="value">￥{{tableData.DiscountAmount}}</span>
              </div>
              <div class="money-item">
                <span class="key">运&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;费：</span>
                <span class="value">￥{{tableData.ShipAmount}}</span>
              </div>
              <div class="money-item all-money">
                <span class="key">应付总额：</span>
                <span class="value font-md">￥{{tableData.SurplusMoney}}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      width="800px"
      title="开发票"
      :visible.sync="invoiceShow"
      :before-close="handleClose"
      append-to-body
    >
      <invoice ref="invoice" :orderId="invoiceOrderId" @closeInvoice="closeInvoice"></invoice>
    </el-dialog>
  </div>
</template>
<script>
import elTableColumn from "@/components/common/chjtablecolumn";
import breadcrumb from "@/components/common/breadcrumb";
import invoice from "@/components/common/invoice";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    breadcrumb,
    invoice,
    elTableColumn
  },
  data() {
    return {
      browseId: "",
      invoiceOrderId: "",
      invoiceShow: false,
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
      downloadUrl: this.$util.QN_URL_BASE,
      stateSp: 0,
      tableData: {},
      searchData: {
        orderId: ""
      }
    };
  },
  activated() {
    this.searchData.orderId = this.$route.query.OrderId;
    this.getTableData();
  },
  mounted() {
    this.browseId = this.$route.query.OrderId;
    this.searchData.orderId = this.$route.query.OrderId;
    this.getTableData();
  },
  methods: {
    gotoApplyDetails(OrderGoodRId) {
      let item = this.tableData;
      if (!item.GoodsList) {
        this.$util.warningMsg("该订单没有可申请售后的商品");
        return;
      }
      this.$router.push(
        `/service/afterApplyDetails?OrderType=5&OrderId=${
          item.OrderId
        }&OrderCode=${item.OrderCode}&OrderGoodRId=${
          OrderGoodRId ? OrderGoodRId : ""
        }`
      );
    },
    buyAgain() {
      this.$util.buyAgain(this.tableData.OrderId);
    },
    // 显示开发票页面
    showInvoice() {
      this.invoiceOrderId = this.tableData.OrderId;
      this.invoiceShow = true;
    },
    handleClose() {
      this.$refs.invoice.clearData();
      this.invoiceShow = false;
    },
    closeInvoice() {
      this.$refs.invoice.clearData();
      this.invoiceShow = false;
    },
    // 返回上一页
    back() {
      window.history.back(-1);
    },
    // 获取数据
    getTableData() {
      this.$util
        .axiosGet({
          url: "/api/PurchaseManager/GetEnptOrderDetail",
          data: this.searchData
        })
        .then(res => {
          let data = res.data;
          if (!data) data = [];
          this.tableData = data;
          let stateList = data.OrderStates;
          for (let i = 0; i < stateList.length; i++) {
            if (stateList[i].IsCurrStep) {
              this.stateSp = i;
              break;
            }
          }
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scoped>
.print {
  cursor: pointer;
}
.order-status {
  display: flex;
  background: @border4Color;
  padding: 20px;
  margin-bottom: 20px;
}

.order-status1 {
  width: 20%;
  border-right: 1px solid @border3Color;
  text-align: center;
  div {
    margin-bottom: 10px;
  }
}
.status-text {
  font-size: @font-lg;
  color: @theme2;
  font-weight: bold;
}

.order-status2 {
  width: 80%;
  padding-left: 20px;
}
.order-dur {
  padding-bottom: 20px;
}
.shop-msg {
  display: flex;
  align-items: center;
}
.shop-cover {
  max-width: 80px;
  max-height: 80px;
}
.money-msg {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}
.money-item {
  width: 182px;
  display: flex;
  justify-content: space-between;
  line-height: 2em;
  font-size: @font-sm;
  .key {
    flex-shrink: 0;
  }
}
.all-money {
  color: red;
}
.pingj-btn {
  width: 80px;
}
.ops-ctn {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  button {
    margin-left: 0;
  }
}
.order-msg-ctn {
  padding: 10px;
  margin-bottom: 20px;
}
.order-msg {
  display: flex;
}
.order-msg-item {
  width: 25%;
  border-right: 1px solid @border4Color;
  padding: 0 10px;
  > div {
    display: flex;
    margin-top: 10px;
  }
  .key {
    width: 100px;
    flex-shrink: 0;
  }
  .value {
    line-height: 1.2em;
  }
}
.order-msg-title {
  font-size: @font-md;
}
</style>
